import { Component, OnInit, ViewChild, ChangeDetectorRef } from '@angular/core';
import { AdminService } from '../services/admin/admin.service';
import { FormControl } from '@angular/forms';
import {
  BsModalRef,
  BsModalService,
  ModalDirective,
} from 'ngx-bootstrap/modal';
import { combineLatest, Subscription } from 'rxjs';
import { HelpersService } from 'src/app/shared/servicio/helpers/helpers.service';

@Component({
  selector: 'app-encueestas',
  templateUrl: './encueestas.component.html',
  styleUrls: ['./encueestas.component.css'],
})
export class EncueestasComponent implements OnInit {
  subscriptions: Subscription[] = [];

  // Propiedades existentes
  listaEncuestas: any[] = [];
  searchtext: FormControl;
  p: number = 1;
  totalItems: number = 0;
  perPage: number = 10;
  direccion: number = 0;
  showLoading: boolean = false;
  edit_id: number = 0;

  // Nuevas propiedades para la API moderna
  useNewApi: boolean = true; // Flag para usar nueva API
  currentFilter: string = 'title';
  currentParam: string = 'none';
  currentOrder: number = 0;
  currentDirection: number = 0;

  // Referencias de modales
  modalRef: BsModalRef;
  modalRef2: BsModalRef;
  @ViewChild(ModalDirective) edit: ModalDirective;

  // Configuraciones de modales
  config3 = {
    class: 'modal-dialog-centered modal-app modal-app-lg',
    backdrop: true,
    ignoreBackdropClick: true,
  };

  config = {
    class: 'modal-dialog-centered modal-app modal-app-lg',
    backdrop: true,
    ignoreBackdropClick: true,
  };

  constructor(
    private admin: AdminService,
    private modalService: BsModalService,
    private changeDetection: ChangeDetectorRef,
    private _helper: HelpersService
  ) { }

  ngOnInit() {
    this.initializeComponent();
    this.setupFormControls();
    this.loadSurveys();
    this.setupSubscriptions();
  }

  /**
   * Inicializa las propiedades del componente
   */
  private initializeComponent() {
    this.showLoading = true;
    this.p = 1;
    this.direccion = 0;
    this.totalItems = 0;
    this.perPage = 10;
    this.edit_id = 0;

    // Inicializar parámetros de filtro
    this.currentFilter = 'none';
    this.currentParam = 'none';
    this.currentOrder = 0;
    this.currentDirection = 0;
  }

  /**
   * Configura los controles del formulario
   */
  private setupFormControls() {
    this.searchtext = new FormControl('');
  }

  /**
   * Configura las suscripciones
   */
  private setupSubscriptions() {
    this.searchtext.valueChanges.subscribe((searchValue) => {
      if (searchValue && searchValue.trim() !== '') {
        this.currentFilter = 'title';  // ✅ Esto está bien
        this.currentParam = searchValue.trim(); // ✅ Esto está bien
      } else {
        this.currentFilter = 'none'; // ✅ Esto está bien
        this.currentParam = 'none';  // ✅ Esto está bien
      }
      this.p = 1;
      this.loadSurveys();
    });
  }

  /**
   * Carga las encuestas usando la API apropiada
   */
  loadSurveys() {
    this.showLoading = true;

    // ✅ VERIFICAR que estos valores se pasen correctamente:
    console.log('Filter:', this.currentFilter); // Debe mostrar 'title' cuando hay búsqueda
    console.log('Param:', this.currentParam);   // Debe mostrar el texto buscado
    console.log('Order:', this.currentOrder);
    console.log('Direction:', this.currentDirection);
    console.log('Page:', this.p);

    const loadMethod = this.useNewApi ?
      this.admin.listSurveysNew(this.currentFilter, this.currentParam, this.currentOrder, this.currentDirection, this.p) :
      this.admin.list_surveys(this.currentFilter, this.currentParam, this.currentOrder, this.currentDirection, this.p);

    loadMethod.subscribe({
      next: (data) => {
        this.handleSurveysResponse(data);
      },
      error: (error) => {
        console.error('Error loading surveys:', error);
        console.error('URL que falló:', error.url); // ✅ AGREGAR para debug
        this.showLoading = false;
        this._helper.modalAlert('Error al cargar las encuestas');
      }
    });
  }

  /**
   * Maneja la respuesta de la API de encuestas
   */
  private handleSurveysResponse(data: any) {
    console.log('Surveys data:', data);

    if (data && data.page_info) {
      this.totalItems = data.page_info.count;
      this.perPage = data.page_info.total_items;
      this.p = data.page_info.current;
      this.listaEncuestas = data.info || [];
    } else {
      // Manejo para formato de respuesta diferente
      this.listaEncuestas = Array.isArray(data) ? data : [];
      this.totalItems = this.listaEncuestas.length;
    }

    this.showLoading = false;
  }

  /**
   * Activa una encuesta
   */
  activateEncuesta(id: number) {
    const activateMethod = this.useNewApi ?
      this.admin.toggleSurveyStatusNew(id, true) :
      this.admin.toggleActivateSurvey(id, true);

    activateMethod.subscribe({
      next: (data) => {
        this.loadSurveys();
        this._helper.modalSuccess('¡Encuesta activada!');
      },
      error: (error) => {
        console.error('Error activating survey:', error);
        this._helper.modalAlert('Error al activar la encuesta');
      }
    });
  }

  /**
   * Desactiva una encuesta
   */
  deactivateEncuesta(id: number) {
    this._helper
      .modalConfirm('¿Desea desactivar la encuesta?')
      .then((willDelete) => {
        if (willDelete.value) {
          const deactivateMethod = this.useNewApi ?
            this.admin.toggleSurveyStatusNew(id, false) :
            this.admin.toggleActivateSurvey(id, false);

          deactivateMethod.subscribe({
            next: (data) => {
              this.loadSurveys();
              this._helper.modalSuccess('¡Encuesta desactivada!');
            },
            error: (error) => {
              console.error('Error deactivating survey:', error);
              this._helper.modalAlert('Error al desactivar la encuesta');
            }
          });
        }
      });
  }

  /**
   * Elimina una encuesta
   */
  eliminarEncuesta(id: number) {
    this._helper
      .modalConfirm('¿Desea eliminar esta encuesta?')
      .then((willDelete) => {
        if (willDelete.value) {
          const deleteMethod = this.useNewApi ?
            this.admin.deleteSurveyNew(id) :
            this.admin.delete_survey(id);

          deleteMethod.subscribe({
            next: (data) => {
              this.loadSurveys();
              this._helper.modalSuccess('¡Encuesta eliminada!');
            },
            error: (error) => {
              console.error('Error deleting survey:', error);
              this._helper.modalAlert('¡No se pudo eliminar la encuesta!');
            }
          });
        }
      });
  }

  /**
   * Exporta una encuesta a Excel
   */
  exportSurveyToExcel(id: number) {
    if (!this.useNewApi) {
      this._helper.modalAlert('La exportación a Excel requiere la nueva API');
      return;
    }

    this.admin.exportSurveyToExcel(id).subscribe({
      next: (blob) => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `encuesta_${id}.xlsx`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
        this._helper.modalSuccess('¡Encuesta exportada exitosamente!');
      },
      error: (error) => {
        console.error('Error exporting survey:', error);
        this._helper.modalAlert('Error al exportar la encuesta');
      }
    });
  }

  /**
   * Obtiene estadísticas de una encuesta
   */
  getSurveyStatistics(id: number) {
    if (!this.useNewApi) {
      this._helper.modalAlert('Las estadísticas requieren la nueva API');
      return;
    }

    this.admin.getSurveyStatistics(id).subscribe({
      next: (stats) => {
        console.log('Survey statistics:', stats);
        // Aquí puedes implementar la lógica para mostrar las estadísticas
        this._helper.modalSuccess('Estadísticas cargadas exitosamente');
      },
      error: (error) => {
        console.error('Error getting survey statistics:', error);
        this._helper.modalAlert('Error al obtener las estadísticas');
      }
    });
  }

  /**
   * Cambia la dirección de ordenamiento
   */
  toggleDireccion() {
    this.showLoading = true;
    this.direccion = this.direccion === 0 ? 1 : 0;
    this.currentDirection = this.direccion;
    this.p = 1; // Resetear a primera página
    this.loadSurveys();
  }

  /**
   * Filtra las encuestas por página
   */
  filter(page: number) {
    this.p = page;
    this.loadSurveys();
  }

  /**
   * Abre el modal para crear una encuesta
   */
  openCreateModal(modalRef: any) {
    this.modalRef = this.modalService.show(modalRef, this.config3);
    this.subscriptions.push(
      this.modalService.onHidden.subscribe(() => {
        this.loadSurveys();
        this.unsubscribe();
      })
    );
  }

  /**
   * Abre el modal para editar una encuesta
   */
  openModal(id: number, modalRef: any) {
    this.edit_id = id;
    this.modalRef2 = this.modalService.show(modalRef, this.config3);
    this.subscriptions.push(
      this.modalService.onHidden.subscribe(() => {
        this.loadSurveys();
        this.unsubscribe();
      })
    );
  }

  /**
   * Desuscribe de todos los observables
   */
  unsubscribe() {
    this.subscriptions.forEach((subscription: Subscription) => {
      subscription.unsubscribe();
    });
    this.subscriptions = [];
  }

  /**
   * Alterna entre la nueva API y la API legacy
   */
  toggleApiMode() {
    this.useNewApi = !this.useNewApi;
    this.loadSurveys();
    this._helper.modalSuccess(
      `Cambiado a ${this.useNewApi ? 'nueva' : 'antigua'} API`
    );
  }

  /**
   * Obtiene el texto del estado de la encuesta
   */
  getSurveyStatusText(survey: any): string {
    return survey.active ? 'Activa' : 'Inactiva';
  }

  /**
   * Obtiene la clase CSS para el estado de la encuesta
   */
  getSurveyStatusClass(survey: any): string {
    return survey.active ? 'text-success' : 'text-muted';
  }

  /**
   * Verifica si una encuesta está activa
   */
  isSurveyActive(survey: any): boolean {
    return survey.active === true;
  }

  /**
   * Formatea la fecha de creación
   */
  formatDate(dateString: string): string {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date.toLocaleDateString('es-ES', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit'
    });
  }

  /**
   * Limpia los recursos al destruir el componente
   */
  ngOnDestroy() {
    this.unsubscribe();
  }
}
